import { motion } from "framer-motion";
import { MapPin, Clock, Truck, Package } from "lucide-react";

const regions = [
  { name: "Hatay", desc: "18:00'den önce verilen siparişler aynı gün teslim edilir — merkez ve civar ilçeler.", time: "18:00'e kadar", primary: true },
  { name: "Adana", desc: "16:00'dan önce verilen siparişler aynı gün teslim edilir.", time: "16:00'a kadar" },
  { name: "Osmaniye", desc: "16:00'dan önce verilen siparişler aynı gün teslim edilir.", time: "16:00'a kadar" },
  { name: "Gaziantep", desc: "16:00'dan önce verilen siparişler aynı gün teslim edilir.", time: "16:00'a kadar" },
  { name: "Türkiye Geneli", desc: "Anlaşmalı kargo firmalarımızla Türkiye'nin her iline güvenli gönderim.", time: "1-3 Gün", icon: Package },
];

export default function DeliveryRegions() {
  return (
    <section className="py-20 md:py-28 lg:py-32 bg-[#F8F8F8]" data-testid="delivery-section">
      <div className="frida-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3">
              · Teslimat ·
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1]" data-testid="delivery-title">
              4 İlde <span className="italic text-[#A85C34]">Aynı Gün</span>, Türkiye Genelinde Kargo
            </h2>
            <p className="mt-6 text-lg text-[#555555] leading-relaxed">
              Profesyonel kurye ağımız ve özenli soğuk zincir taşımacılığımız ile çiçekleriniz tazeliğini koruyarak ulaşır; anlaşmalı kargo firmalarımızla Türkiye'nin her iline gönderim yapıyoruz.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#urunler"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#A85C34] hover:bg-[#8B4726] text-white rounded-full font-medium transition-colors"
                data-testid="delivery-order-button"
              >
                <Truck className="w-4 h-4" />
                Hemen Sipariş Ver
              </a>
              <div className="inline-flex items-center gap-2 px-5 py-3 bg-white border border-[#EAEAEA] rounded-full text-sm">
                <Clock className="w-4 h-4 text-[#D4A15C]" />
                <span className="font-medium">7/24 Hizmet</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {regions.map((r, i) => (
              <motion.div
                key={r.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`relative rounded-3xl p-7 lg:p-8 lift-card overflow-hidden ${
                  r.primary
                    ? "bg-[#222222] text-white border border-[#222222]"
                    : "bg-white border border-[#EAEAEA]"
                }`}
                data-testid={`region-card-${r.name.toLowerCase()}`}
              >
                <div className="flex items-center justify-between mb-6">
                  {(() => { const Icon = r.icon || MapPin; return <Icon className={`w-6 h-6 ${r.primary ? "text-[#D4A15C]" : "text-[#A85C34]"}`} />; })()}
                  <span className={`text-[10px] font-semibold tracking-[0.2em] uppercase px-3 py-1.5 rounded-full ${
                    r.primary ? "bg-[#D4A15C] text-[#222222]" : "bg-[#F5E9DD] text-[#A85C34]"
                  }`}>
                    {r.time}
                  </span>
                </div>
                <h3 className="font-serif text-3xl lg:text-4xl mb-3 tracking-tight">{r.name}</h3>
                <p className={`leading-relaxed ${r.primary ? "text-white/75" : "text-[#555555]"}`}>
                  {r.desc}
                </p>

                {r.primary && (
                  <div className="absolute -right-10 -bottom-10 w-40 h-40 rounded-full bg-[#D4A15C]/20 blur-3xl pointer-events-none" />
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
